export default {"src":"/_next/static/media/6.d479d7ed.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};